import { render, staticRenderFns } from "./SemiologiaOtorrinolaringologica.vue?vue&type=template&id=50fd5db0"
import script from "./SemiologiaOtorrinolaringologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaOtorrinolaringologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports